export default "__VITE_ASSET__ZrOCP$T4__"